import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1054882"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "break-spaces text-break border-bottom url-item"
}
const _hoisted_2 = ["href"]


export default /*#__PURE__*/_defineComponent({
  props: {
  siteName: {
    type: String,
    required: true,
  },
  siteUrl: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.siteName && __props.siteUrl)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          href: __props.siteUrl,
          target: "_blank"
        }, _toDisplayString(__props.siteName), 9, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})